<template>
    <div class="hrm_input">
        <label class="hrm_input_label text-sm font-medium text-gray-800 dark:text-gray-400">{{
            trans("lang.labels.country") }}
        </label>
        <div class="relative mt-2">
            <VueMultiselect class="hrm-vuemultiselect hrm_input_field" v-model="filterData.country"
                :options="countries" @select="onChangeCountry" @clear="onClearCountry"
                :placeholder="trans('lang.labels.Select')" label="name" valueProp="name" :searchable="true" />
        </div>
    </div>
    <div class="theme-input hrm_input">
        <label class="hrm_input_label text-sm font-medium text-gray-800 dark:text-gray-400">{{
            trans("lang.labels.state") }}
        </label>
        <div class="relative mt-2">
            <VueMultiselect :key="componentKey" class="hrm-vuemultiselect" v-model="filterData.state"
                @select="onChangeState" @clear="onClearState" :options="states"
                :placeholder="trans('lang.labels.Select')" label="name" valueProp="name" :searchable="true" />
        </div>
    </div>
    <div class="theme-input hrm_input">
        <label class="hrm_input_label text-sm font-medium text-gray-800 dark:text-gray-400">{{
            trans("lang.labels.city") }}
        </label>
        <div class="relative mt-2">
            <VueMultiselect :key="componentKey" class="hrm-vuemultiselect" v-model="filterData.city"
                :options="cities" :placeholder="trans('lang.labels.Select')" label="name" valueProp="name"
                :searchable="true" @clear="onClearCity" />
        </div>
    </div>
</template>
<script setup>
import { onMounted, ref } from 'vue';
import VueMultiselect from "@vueform/multiselect";

const props = defineProps({
    filterItem: { type: Object },
    filterData: { type: Object, required: true },
});


const countries = ref([])
const states = ref([])
const cities = ref([])

const componentKey = ref(1)

const onChangeCountry = async () => {
    await getStates(props.filterData.country);
}

const onClearCountry = () => {
    props.filterData.country = null;
    props.filterData.state = null;
    props.filterData.city = null;
    states.value = [];
    cities.value = [];
    componentKey.value += 1;
}

const onChangeState = () => {
    getCities(props.filterData.state);
}

const onClearState = () => {
    props.filterData.state = null;
    props.filterData.city = null;
    cities.value = [];
    componentKey.value += 1;
}

const onClearCity = () => {
    props.filterData.city = null;
}

const getCountries = async () => {
    try {
        const response = await axios.get(route("hrm.countries.index"));
        countries.value = response.data.data;
    } catch (error) {
        console.error("Error fetching locations:", error);
    }
};

const getStates = async (code) => {
    try {
        const response = await axios.get(route("hrm.states.index", { country_name: code }))
        states.value = response.data.data;
    } catch (error) {
        console.error("Error fetching States:", error);
    }
};

const getCities = async (code) => {
    try {
        const response = await axios.get(route("hrm.cities.index", { state_name: code, country_name: props.filterData.country, }))
        cities.value = response.data.data;
    } catch (error) {
        console.error("Error fetching locations:", error);
    }
};

onMounted(async () => {
    await getCountries();
});


</script>